module.exports = __webpack_public_path__ + "static/hero-9edfc729ec25d52bc3ef004d97f09a19.jpg";